





























































































































































































































































































































































































































































import IconButton from "@/components/IconButton.vue";
import Vue from "vue";
import CarItemRelation from "../models/CarItemRelation";
import * as api from "../services/CarNetApi";
import flowStore, { InvoiceFlowStore } from "@/modules/invoiceFlow/services/InvoiceFlowStore";
import itemStore, { InvoiceItemStore } from "@/modules/invoiceItems/services/store";
import MoneyDisplay from "@/components/MoneyDisplay.vue";
import MoneyInput from "@/components/MoneyInput.vue";
import CarItem from "../models/CarItem";
import CheckBox from "@/components/CheckBox.vue";
import CarPreCalcInfo from "@/modules/canNet/components/CarPreCalcInfo.vue";
import { InvoiceItem } from "@/modules/invoiceItems/models";
import kanriStore, { KanriInvoiceStore } from "@/modules/kanri/services/KanriInvoiceStore";

interface Data {
  flowStore: InvoiceFlowStore;
  itemStore: InvoiceItemStore;
  kanriStore: KanriInvoiceStore;
  searchText: string;

  selectedItems: CarItem[];
  loaded: boolean;
  showSelectWarning: boolean;
}

interface Methods {
  saveGroup(): void;
  search(e: KeyboardEvent, gPartId: number): void;
  clear(): void;
  deleteItem(item: CarItemRelation): void;
  preSelectItem(item: CarItem): void;
  selectItem(item: CarItem, selectAnother: boolean): void;
  addItems(): void;
  showDetails(item: CarItemRelation): void;
  getSearchCols(): any[];
  getInfoCols(): any[];
}

interface Props {
  invItemId: number;
  isPageDisabled: boolean;
  item: InvoiceItem;
}

interface Computed {
  isPostCalc: boolean;
  carIdComputed: number;
  searchCols: any[];
  infoCols: any[];
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: { IconButton, MoneyDisplay, CheckBox, MoneyInput, CarPreCalcInfo },
  props: {
    invItemId: { type: Number },
    isPageDisabled: { type: Boolean },
    item: { type: InvoiceItem},
  },

  data() {
    return {
      flowStore,
      itemStore,
      kanriStore,
      newCarItemRelations: [],
      searchText: "",

      selectedItems: [],
      loaded: false,
      showSelectWarning: false,
      carItemRelations: [],
    };
  },

  async beforeMount() {    
    this.item.carItemRelations = (
      await api.getCurrentCarItemRelations(Number(this.invItemId))
    ).map((x: CarItemRelation) => ({ ...x, details: false}));
    this.loaded = true;
  },

  methods: {
    async saveGroup() {
      await this.flowStore.updateCarRelationItems(this.item.carItemRelations);
    },

    async search(e: KeyboardEvent, gPartId: number) {
      if (e.key != "Enter") {
        return;
      }

      //Utókalkuláció nélküli kapcsolásnál csak az gj törzsből listázunk
      if (!this.isPostCalc) {
        this.item.newCarItemRelations = (
          await api.searchSerCarItemRelations(this.searchText, gPartId)
        ).map((x: CarItem) => ({ ...x, isSelected: false, showSelectWarning: false }));
        return;
      }

      this.item.newCarItemRelations = (
        await api.searchCarItemRelations(this.searchText, this.flowStore.invoice.partner, gPartId)
      ).map((x: CarItem) => ({ ...x, isSelected: false, showSelectWarning: false  }));

      if (this.item.newCarItemRelations.length == 0 && this.searchText.length == 17) {
        await kanriStore.downSyncKanriCar(this.flowStore.invoice.partner, this.searchText);

        this.item.newCarItemRelations = (
          await api.searchCarItemRelations(this.searchText, this.flowStore.invoice.partner, gPartId)
        ).map((x: CarItem) => ({ ...x, isSelected: false, showSelectWarning: false  }));
      }
    },

    clear() {
      this.item.newCarItemRelations = [];
      this.searchText = "";
    },

    async deleteItem(item: CarItemRelation) {
      this.item.carItemRelations = this.item.carItemRelations.filter((x) => x.id != item.id);
      await api.deleteCarItemRelation(item.id);
    },

    preSelectItem(item) {
      if (!this.isPostCalc) {
        this.selectItem(item, false);
        return;
      }
      if (!item.isSelected && !item.sameCarTypeAsInvItem) {
        item.showSelectWarning = true;
      } else if (!item.isSelected && !item.gpartNewShc && item.hasOpenPostCalc && ![2,3].some(x => x == item.postCalcStatus) && this.item.newCarItemRelations.some(i => i.car == item.car && i.prCar == item.prCar && i.samePostCalcTypeAsInvItem && i.postCalcStatus == 2)) {
        item.showSelectWarning = true;
      } else if (!item.isSelected && item.gpartNewShc && item.hasNewShcPostCalc && item.postCalcStatus == 1) {
        item.showSelectWarning = true;
      } else {
        this.selectItem(item, false);
      }
    },

    selectItem(item, selectAnother) {
      if (!item.isSelected) {
        let selectedItem;
        if (selectAnother) {
          selectedItem = this.item.newCarItemRelations.find(i => i.car == item.car && i.prCar == item.prCar && i.samePostCalcTypeAsInvItem && (i.postCalcStatus == 2 || (i.postCalcNewShc !== false && i.postCalc != 1)));
        } else {
          selectedItem = item;
        }

        if (selectedItem)
        {
          this.selectedItems = [];
          this.$props.item.newCarItemRelations.forEach((item: CarItem) => { item.isSelected = false; });

          selectedItem.isSelected = true;
          this.selectedItems.push(selectedItem);
        }
      } else {
        this.selectedItems = [];
        item.isSelected = false;
      }
      item.showSelectWarning = false;
    },

    async addItems() {
      if (this.selectedItems.length == 0) {
        return;
      }
      if (!this.isPostCalc) {
        await api.addCarItemRelationWithoutPostCalc(
          this.selectedItems,
          Number(this.$route.params.invoiceId),
          Number(this.invItemId)
        );
      } else {
        await api.addCarItemRelation(
          this.selectedItems,
          Number(this.$route.params.invoiceId),
          Number(this.invItemId)
        );
      }

      this.item.newCarItemRelations = [];
      this.item.carItemRelations = await api.getCurrentCarItemRelations(Number(this.invItemId));

      this.selectedItems = [];
    },

    async showDetails(item: CarItemRelation) {
      item.details = !item.details;
    },

    getInfoCols() {
      const hidden = [
        "postCalc",
        "postCalcNewShc",
        "postCalcStatusName", 
        "postCalcOpenDate",
        "postCalcCloseDate",
      ];

      return this.isPostCalc
        ? this.infoCols
        : this.infoCols.filter((c: { field?: string }) => !hidden.includes(c.field ?? ""));
    },

    getSearchCols() {
      const hidden = [
        "postCalc",
        "postCalcNewShc",
        "postCalcStatusName",
        "postCalcOpenDate",
        "postCalcCloseDate",
        "currNetto",
        "currVat",
        "currTotal"
      ];

      return this.isPostCalc
        ? this.searchCols
        : this.searchCols.filter((c: { field?: string }) => !hidden.includes(c.field ?? ""));
    },


  },

  computed: {
    isPostCalc() {
      return this.item.isPostCalc;
    },

    carIdComputed() {
      if (this.item.carItemRelations.length == 0 || this.item.carItemRelations == null || this.item.carItemRelations == undefined) {
        return 1;
      }
      return Number((this.item.carItemRelations[0] as CarItemRelation).car);
    },

    infoCols: () => [
      {
        cell: "detailsButtonTemplate",
        filterable: false,
        width: "50px",
      },
      { field: "car", title: "Gépj.", width: "55px" },
      { field: "prCar", title: "Gépj. rend.", width: "55px" },
      { field: "postCalc", title: "Utókalk.", width: "70px" },
      { field: "postCalcNewShc", cell: "postCalcNewShc", title: "Utókalk. típusa", width: "75px" },
      { field: "postCalcStatusName", cell: "postCalcStatusName", title: "Utókalk. státusza", width: "90px" },
      { field: "postCalcOpenDate", cell: "postCalcOpenDate", title: "Utókalk. kezdete", width: "80px" },
      { field: "postCalcCloseDate", cell: "postCalcCloseDate", title: "Utókalk. vége", width: "80px" },
      { field: "currNetto", title: "Nettó", cell: "nettoTemplate" },
      { field: "currVat", title: "Gépjárműre felosztandó ÁFA", cell: "vatTemplate" },
      { field: "currTotal", title: "Gépjárműre felosztandó", cell: "totalTemplate" },
      { cell: "commandTemplate", width: "55px" },
      { width: 0 },
    ],

    searchCols: () => [
      { field: "car", title: "Gépj.", width: "50px" },
      { field: "prCar", title: "Gépj. rend.", width: "50px" },
      { field: "carStatus", cell: "carStatus", title: "Gépj. státusza", width: "70px" },
      { field: "carBrandName", cell: "carBrandName", title: "Gyártó", width: "80px" },
      { field: "modelName", cell: "modelName", title: "Modell" },
      { field: "bodyNo", cell: "bodyNo", title: "Alvázszám", width: "145px" },
      { field: "engineNo", cell: "engineNo", title: "Motorszám" },
      { field: "regNum", cell: "regNum", title: "Rendszám", width: "80px" },
      { field: "postCalc", title: "Utókalk.", width: "70px", className: "grey-text" },
      { field: "postCalcNewShc", cell: "postCalcNewShc", title: "Utókalk. típusa", width: "70px" },
      { field: "postCalcStatusName", cell: "postCalcStatusName", title: "Utókalk. státusza", width: "85px" },
      { field: "postCalcOpenDate", cell: "postCalcOpenDate", title: "Utókalk. kezdete", width: "75px" },
      { field: "postCalcCloseDate", cell: "postCalcCloseDate", title: "Utókalk. vége", width: "75px" },
      { cell: "commandTemplate", width: "50px" },
      { width: 0 },
    ],
  },
});
